import Vue from "vue";
import parent from "../advertising";

export default {
    optionsUrl({ interactionId, advertisingId }) {
        return `${parent.url()}/${advertisingId}/interacao/${interactionId}/opcao`;
    },

    async load({ interactionId, advertisingId }) {
        const url = this.optionsUrl({ interactionId, advertisingId });

        return await Vue.http.get(url);
    },

    async create({ interactionId, advertisingId, data }) {
        const url = this.optionsUrl({ interactionId, advertisingId });

        return await Vue.http.post(url, data || {});
    },

    async edit({ optionId, interactionId, advertisingId, data }) {
        const url = `${this.optionsUrl({
            interactionId,
            advertisingId,
        })}/${optionId}`;

        return await Vue.http.patch(url, data);
    },

    async remove({ optionId, interactionId, advertisingId }) {
        const url = `${this.optionsUrl({
            interactionId,
            advertisingId,
        })}/${optionId}`;

        return await Vue.http.delete(url);
    },

    async bindInteraction({ optionId, interactionId, advertisingId, nextId }) {
        const url = `${this.optionsUrl({
            interactionId,
            advertisingId,
        })}/${optionId}/vinculo/${nextId}`;

        return await Vue.http.post(url);
    },

    async unbindInteraction({ optionId, interactionId, advertisingId }) {
        const url = `${this.optionsUrl({
            interactionId,
            advertisingId,
        })}/${optionId}/vinculo`;

        return await Vue.http.delete(url);
    },

    async linkIntegration({
        optionId,
        interactionId,
        advertisingId,
        integrationId,
    }) {
        const url = `${this.optionsUrl({
            interactionId,
            advertisingId,
        })}/${optionId}/integracao/${integrationId}`;

        return Vue.http.post(url);
    },

    async unlinkIntegration({ optionId, interactionId, advertisingId }) {
        const url = `${this.optionsUrl({
            interactionId,
            advertisingId,
        })}/${optionId}/integracao/`;

        return Vue.http.delete(url);
    },
};
